module.exports = __webpack_public_path__ + "img/start.3054fc7d.png";